module.exports = {"states":["listed","requested","invited","confirmed","pending","cancelled","waitlisted","waitlist_prio","declined","adopted","silent","optional"]}


//////////////////
// WEBPACK FOOTER
// ./src/app/components/deposits/rsvps.json
// module id = 144
// module chunks = 1